<cs-card-list>
  <!-- Header with title and projected action buttons. On the meal screen an empty meal's header
       names the recent-meals section under it instead of "Foods", and a meal with nothing to
       repeat has no header at all -- a heading over nothing is only noise (#5522). -->
  @if ((showHeader && !hidesHeaderForEmptyMeal) || reorderMode) {
    <cs-card-list-row class="ingredient-list-header">
      @if (showHeader) {
        <span class="header-title">{{ headerTitle }}</span>
      }
      @if (showsRecentMealsSection) {
        <!-- the section's one action sits at the right end of its title row, where other cards
             put theirs (the meal macros card's Nutrients link, for one) -->
        <div class="header-actions">
          <cs-button tertiary icon-right icon="keyboard-arrow-right" id="viewAllRecentMeals"
            (click)="handleViewAllRecentMeals()">
            {{ LL.ingredientSearch.buttons.viewAll() }}
          </cs-button>
        </div>
      }
      @if (ingredients.length > 0) {
        <div class="header-actions">
          @if (reorderMode) {
            <cs-button primary small (click)="exitReorderMode()">
              {{ LL.ingredientSearch.buttons.done() }}
            </cs-button>
          } @else {
            <!-- Parent page injects buttons here -->
            <ng-content select="[ingredient-list-header-actions]"></ng-content>
            <!-- Ellipsis menu button (parent-controlled or auto-shown for reorder on mobile) -->
            @if (showHeaderMenu || showReorderMenuButton) {
              <cs-icon-button icon="ellipsis-vertical"
              (click)="onHeaderMenuClick($event)"></cs-icon-button>
            }
          }
        </div>
      }
    </cs-card-list-row>
  }

  <!-- Loading spinner -->
  @if (showIngredientLoadSpinner) {
    <cs-card-list-row class="loading-spinner">
      <cs-spinner></cs-spinner>
    </cs-card-list-row>
  }

  @if (!showIngredientLoadSpinner) {
    <!-- Ingredient cards -->
    @for (ingredient of ingredients; track trackByIngredient($index, ingredient); let ingredientIndex = $index) {
      @if (ingredientDataFor(ingredient)) {
        <cs-food-card class="ingredient-item"
          [class.dragging]="dragService.isDragging(ingredientIndex)"
          [food]="mapIngredientToFoodHeader(ingredient)"
          [servingUnit]="isIngredientReal(ingredient) ? ingredient.custom_unit : undefined"
          [servingAmount]="getIngredientServingAmount(ingredient)" [weight]="ingredient.weight_g"
          [weightUnit]="ingredient.weight_unit || 'g'" [isLocked]="isIngredientLocked(ingredient)"
          [showMenuButton]="!isReadOnly || isIngredientReal(ingredient)" [showDragHandle]="showDragHandles"
          (menuClick)="showIngredientMenu($event.event, ingredient)"
          (dragHandleDown)="onDragHandleStart($event, ingredient, ingredientIndex)"
          (pointerdown)="onDragStart($event, ingredient, ingredientIndex)"
          (click)="onIngredientClick($event, ingredientIndex)">
        </cs-food-card>
      }
    }
    @if (validityMessage) {
      <cs-card-list-row class="validation-row">
        <vld-message [validity]="validityMessage" [immediate]="validityMessageImmediate"></vld-message>
      </cs-card-list-row>
    }
    <!-- Empty state: the recent meals, or the recipe editor's two buttons.
         The meal screen's add-food routes live in its own block at the top of the page (#4969).
         On the meal screen the card is drawn only while there are recent meals to put in it. -->
    @if (ingredients.length === 0 && !isReadOnly && (!showRecentMeals || showsRecentMealsSection)) {
      <cs-card class="empty-state" [class.simple]="!showRecentMeals" [class.recent-meals]="showRecentMeals">
        <div class="empty-state-wrapper">
          <!-- The glyph and the "select foods" heading belong to the RECIPE editor's empty state,
               which is the only screen where this card is still the only thing telling the user
               what to do. The meal screen's own add-food routes sit directly above this list, so
               drawing a second, weaker version of them here read as a mistake (#4969). -->
          @if (!showRecentMeals) {
            <div class="empty-state-header">
              <cs-icon name="nutrition"></cs-icon>
              <span class="empty-state-title">{{ emptyStateTitle }}</span>
            </div>
          }
          @if (showRecentMeals) {
            <cs-recent-meals-empty-state [recentMeals]="recentMeals" [recentMealsLoading]="recentMealsLoading"
              [currentMealName]="currentMealName" (repeatMeal)="handleRepeatLastMeal($event)"
              (openMeal)="handleRecentMealClick($event)">
            </cs-recent-meals-empty-state>
          }
          <!-- Simple buttons (for recipe empty state) -->
          @if (!showRecentMeals) {
            <div class="empty-state-buttons simple">
              <cs-button secondary icon="add" (click)="handleAddFoods()">
                {{ LL.ingredientSearch.buttons.addFoods() }}
              </cs-button>
              <cs-button secondary icon="edit" (click)="handleLogMacrosManually()">
                {{ LL.ingredientSearch.buttons.logMacrosManually() }}
              </cs-button>
            </div>
          }
        </div>
      </cs-card>
    }
    <!-- Footer with Add Food button (hidden in reorder mode, and on any screen that offers its
         own way to add food just above the list -- see showAddFoodFooter) -->
    @if (!isReadOnly && ingredients.length > 0 && !reorderMode && showAddFoodFooter) {
      <cs-card-list-row class="ingredient-list-footer">
        <cs-button tertiary icon="add" (click)="handleFindFood()">
          {{ LL.ingredientSearch.addFood() }}
        </cs-button>
      </cs-card-list-row>
    }
  }
</cs-card-list>
